import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Select } from 'components/Form'
import { createApiRecord } from 'services/InvoiceService'
import { useDispatch, useSelector } from 'react-redux'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
import { Upload } from 'components/Ui'
injectReducer('uploadInvoices', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.number().required('Please select company'),
    transport_provider: Yup.number().required(
        'Please select transport service provider',
    ),
    client: Yup.number().nullable(),
})

const Create = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { companyData, clientCompanyData, transportProviderData } =
        useSelector((state) => state.listData)
    const { view, loading } = useSelector((state) => state.uploadInvoices.data)

    const handleDiscard = () => navigate('/invoices/upload-invoices')

    const handleSubmit = (values, setSubmitting) => {
        setSubmitting(true)
        var formdata = new FormData()
        if (values?.invoice[values?.invoice.length - 1]?.name) {
            formdata.append(
                'invoice',
                values?.invoice[values?.invoice?.length - 1],
                values?.invoice[values?.invoice.length - 1]?.name,
            )
        } else {
            for (let i = 0; i < values.files.length; i++) {
                formdata.append('files', values.files[i])
            }
        }
        values?.client && formdata.append('client', values.client)
        formdata.append('company', values.company)
        formdata.append('transport_provider', values.transport_provider)
        formdata.append('user', 1)
        createApiRecord(formdata)
            .then(() => {
                Success('Created Successfully!')
                handleDiscard()
                // dispatch(getCompanyData())
                setSubmitting(false)
            })
            .catch((error) => {
                setSubmitting(false)
                return error
            })
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Upload Invoice
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {'Upload New Invoice'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company &&
                                                        touched.company
                                                    }
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'client',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.filter(
                                                        (item) =>
                                                            item?.client &&
                                                            item?.company?.id.toString() ===
                                                                values?.company,
                                                    )}
                                                    label="Client Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.client &&
                                                        touched.client
                                                    }
                                                    message={errors.client}
                                                    value={values?.client}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <div className="col-span-6">
                                            <Field name="invoice">
                                                {({ field, form }) => (
                                                    <Upload
                                                        label="Upload Invoice"
                                                        onFilesSelected={(
                                                            files,
                                                        ) =>
                                                            form.setFieldValue(
                                                                field.name,
                                                                files,
                                                            )
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
